import React, { useContext,useEffect,useState } from 'react';
import { ConnectivityContext } from "../context/ConnectivityContext";

export default function Index() {

  const [userdetails, setuserdetails] = useState();
  const { mode, setMode, networkOnline, effectiveMode, pendingSyncCount, runSync, syncing } = useContext(ConnectivityContext);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      console.log(token);
      setuserdetails(JSON.parse(token));
      // You can set this to state or use in API calls
    } else {
      console.log('No token found');
    }
  }, []);
  return (
    <><div className="appHeader bg-primary text-light">
    <div className="left">
      
    </div>
    <div className="pageTitle">
     <h4 style={{color:'white',fontWeight:'700',fontSize:'18px',textTransform:'capitalize'}}>{userdetails?.w_name} - {userdetails?.w_phone}</h4>
     <div style={{ color: "white", fontSize: "12px" }}>
      {networkOnline ? "🟢 Online" : "🔴 Offline"} | Mode: {mode} ({effectiveMode})
     </div>
     <div style={{ display: "flex", gap: "6px", marginTop: "6px", alignItems: "center", justifyContent: "center" }}>
      <select
        value={mode}
        onChange={(e) => setMode(e.target.value)}
        style={{ fontSize: "12px", padding: "2px 6px" }}
      >
        <option value="auto">Auto</option>
        <option value="online">Online</option>
        <option value="offline">Offline</option>
      </select>
      <button
        className="btn btn-light btn-sm"
        onClick={runSync}
        disabled={syncing || !networkOnline}
        style={{ fontSize: "11px", padding: "2px 8px" }}
      >
        {syncing ? "Syncing..." : "Sync Now"}
      </button>
     </div>
     <div style={{ color: "white", fontSize: "11px" }}>
      {pendingSyncCount} orders pending
     </div>
    </div>
    <div className="right">
     
     
    </div>
  </div>
   
  </>
  )
}
